import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2d84da8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "data-cy": "bilder-ansicht" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-4 mb-0 font-bold" }, " Bilder ", -1))
const _hoisted_3 = { class: "flex flex-row justify-between" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "flex justify-center items-center h-40",
  style: {"background":"rgb(237, 237, 237)"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-center text-gray-400 mx-2 w-28" }, " Bild nicht verfügbar ", -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageObjects, (imgObj) => {
        return (_openBlock(), _createElementBlock("div", { key: imgObj }, [
          (_ctx.getPhotoUrl(imgObj))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.getPhotoUrl(imgObj),
                "data-cy": "image"
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true),
          (imgObj?.imageNotAvailable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}